const StatCard = ({ label, value }) => (
  <div className="stat-card" data-testid={`stat-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
    <div className="stat-value">{value}</div>
    <div className="stat-label">{label}</div>
  </div>
);

// Static row metadata — hoisted to module scope to avoid recreating on every render.
const MOCK_ROW_1_META = { entry: "₹44.20", l1: "₹52.00", l2: "₹58.50", risk: "₹42.00" };
const MOCK_ROW_2_META = { entry: "₹380.00", l1: "₹420.00", l2: "₹455.00", risk: "₹365.00" };
const MOCK_ROW_2_STYLE = { marginTop: "18px" };

const MockWatchRow = ({ sym, name, price, roi, barWidth, meta, style }) => (
  <>
    <div className="mock-row" style={style}>
      <div className="mock-left">
        <div className="mock-sym">{sym}</div>
        <div className="mock-name">{name}</div>
      </div>
      <div className="mock-right">
        <div className="mock-price up">{price}</div>
        <div className="mock-roi up">▲ {roi}</div>
      </div>
    </div>
    <div className="mock-bar">
      <div className="mock-bar-fill" style={{ width: barWidth }} />
    </div>
    <div className="mock-meta">
      <span>Study Entry {meta.entry}</span>
      <span>Level 1 {meta.l1}</span>
      <span>Level 2 {meta.l2}</span>
      <span className="red">Risk {meta.risk}</span>
    </div>
  </>
);

const HeroCopy = ({ onLogin }) => (
  <div className="hero-content">
    <div className="hero-eyebrow reveal" data-testid="hero-eyebrow">
      AI-Powered Stock Research · Market Intelligence · Institutional-Grade Analytics
    </div>
    <h1 className="hero-title reveal" data-testid="hero-title">
      <span className="gold">KIRA MARKETS</span>
      <br />
      A research workspace for{" "}
      <span className="gold">learning the markets</span>.
    </h1>
    <p className="hero-sub reveal" data-testid="hero-sub">
      Built for traders and learners to track market structure, technical
      setups, watchlists, and research notes. A clean, distraction-free
      educational analytics terminal — inspired by Bloomberg &amp; TradingView.
    </p>
    <div className="hero-cta reveal">
      <button
        className="btn btn-gold btn-lg"
        onClick={onLogin}
        data-testid="hero-signup-btn"
      >
        Create free account →
      </button>
      <a
        href="/client-login.html"
        className="btn btn-ghost btn-lg"
        data-testid="hero-login-btn"
      >
        Sign In
      </a>
    </div>

    <div className="hero-stats reveal" data-testid="hero-stats">
      <StatCard label="Stocks Tracked" value="120+" />
      <StatCard label="Sectors Covered" value="16" />
      <StatCard label="Watchlists" value="∞" />
      <StatCard label="Research Notes" value="Daily" />
    </div>
  </div>
);

const HeroMockCard = () => (
  <div className="hero-card reveal" data-testid="hero-mock">
    <div className="mock-head">
      <div className="mock-dot red" />
      <div className="mock-dot amber" />
      <div className="mock-dot green" />
      <div className="mock-title">Market Watch · Educational</div>
    </div>
    <MockWatchRow
      sym="SUZLON"
      name="Suzlon Energy Ltd"
      price="₹45.50"
      roi="2.10%"
      barWidth="62%"
      meta={MOCK_ROW_1_META}
    />
    <MockWatchRow
      sym="LICHSGFIN"
      name="LIC Housing Finance"
      price="₹385.00"
      roi="1.16%"
      barWidth="38%"
      meta={MOCK_ROW_2_META}
      style={MOCK_ROW_2_STYLE}
    />
    <div className="mock-disclaimer">
      For educational study of price structure only. Not a buy/sell recommendation.
    </div>
  </div>
);

export const HeroSection = ({ onLogin }) => (
  <section className="hero">
    <HeroCopy onLogin={onLogin} />
    <HeroMockCard />
  </section>
);
